(function () {
  var namespace = '__toquiBodyFillAnimation';

  if (window[namespace] && typeof window[namespace].initAll === 'function') {
    window[namespace].initAll(document);
    return;
  }

  var initializedSections = new WeakMap();

  function forEachSection(root, callback) {
    var scope = root && root.nodeType === 1 ? root : document;

    if (scope.matches && scope.matches('.toqui-body-fill-animation')) {
      callback(scope);
    }

    scope.querySelectorAll('.toqui-body-fill-animation').forEach(callback);
  }

  function initSection(section) {
    if (!section || initializedSections.has(section)) return;

    var stage = section.querySelector('[data-body-stage]');
    var leftFill = section.querySelector('[data-body-fill="left"]');
    var rightFill = section.querySelector('[data-body-fill="right"]');
    var leftCounter = section.querySelector('[data-body-counter="left"]');
    var rightCounter = section.querySelector('[data-body-counter="right"]');
    if (!stage || !leftCounter || !rightCounter) return;

    initializedSections.set(section, null);

    var fillBottom = 402;
    var fillHeight = 384;
    var styles = window.getComputedStyle(section);
    var leftTarget = Math.max(0, Math.min(100, parseFloat(section.dataset.leftTarget || '0')));
    var rightTarget = Math.max(0, Math.min(100, parseFloat(section.dataset.rightTarget || '0')));
    var shouldAnimate = section.dataset.animate === 'true';
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var requestFrame = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 16); };
    var duration = Math.max(800, Math.min(2600, parseFloat(section.dataset.animationDuration || '1400')));
    var hasPlayed = false;
    var observer = null;
    var fallbackStarted = false;
    var animationDelayTimer = null;
    var animationDelay = 1000;

    function cssVar(name, fallback) {
      var value = styles.getPropertyValue(name);
      return value ? value.trim() : fallback;
    }

    function resolveTiming(style) {
      var timings = {
        sync: [0, 0],
        stagger: [0, 180],
        right_lead: [160, 0]
      };

      if (style === 'random') {
        var keys = ['sync', 'stagger', 'right_lead'];
        style = keys[Math.floor(Math.random() * keys.length)];
      }

      return timings[style] || timings.sync;
    }

    var delays = resolveTiming(section.dataset.animationStyle || 'random');

    function easeOutCubic(value) {
      return 1 - Math.pow(1 - value, 4);
    }

    function buildSilhouetteMask(image) {
      var width = image.naturalWidth || image.width;
      var height = image.naturalHeight || image.height;
      var source = document.createElement('canvas');
      var sourceContext = source.getContext('2d', { willReadFrequently: true });
      var pixelCount = width * height;
      var solid = new Uint8Array(pixelCount);
      var closed;
      var outside = new Uint8Array(pixelCount);
      var queue = new Int32Array(pixelCount);
      var head = 0;
      var tail = 0;
      var x;
      var y;
      var index;
      var imageData;
      var data;

      source.width = width;
      source.height = height;
      sourceContext.clearRect(0, 0, width, height);
      sourceContext.drawImage(image, 0, 0, width, height);
      imageData = sourceContext.getImageData(0, 0, width, height);
      data = imageData.data;

      for (index = 0; index < pixelCount; index += 1) {
        if (data[(index * 4) + 3] > 12) solid[index] = 1;
      }

      closed = new Uint8Array(solid);
      for (y = 1; y < height - 1; y += 1) {
        for (x = 1; x < width - 1; x += 1) {
          index = (y * width) + x;
          if (!solid[index]) continue;

          closed[index - 1] = 1;
          closed[index + 1] = 1;
          closed[index - width] = 1;
          closed[index + width] = 1;
        }
      }

      function pushOutside(px, py) {
        var outsideIndex;
        if (px < 0 || px >= width || py < 0 || py >= height) return;
        outsideIndex = (py * width) + px;
        if (closed[outsideIndex] || outside[outsideIndex]) return;
        outside[outsideIndex] = 1;
        queue[tail] = outsideIndex;
        tail += 1;
      }

      for (x = 0; x < width; x += 1) {
        pushOutside(x, 0);
        pushOutside(x, height - 1);
      }

      for (y = 0; y < height; y += 1) {
        pushOutside(0, y);
        pushOutside(width - 1, y);
      }

      while (head < tail) {
        index = queue[head];
        head += 1;
        x = index % width;
        y = (index - x) / width;

        pushOutside(x + 1, y);
        pushOutside(x - 1, y);
        pushOutside(x, y + 1);
        pushOutside(x, y - 1);
      }

      var componentMap = new Int32Array(pixelCount);
      var componentQueue = new Int32Array(pixelCount);
      var components = [];
      var centerMin = width * 0.38;
      var centerMax = width * 0.62;

      function canVisit(componentIndex) {
        return !closed[componentIndex] && !outside[componentIndex] && !componentMap[componentIndex];
      }

      for (index = 0; index < pixelCount; index += 1) {
        if (!canVisit(index)) continue;

        var componentId = components.length + 1;
        var component = {
          area: 0,
          minX: width,
          maxX: 0,
          minY: height,
          maxY: 0,
          centerHits: 0
        };

        head = 0;
        tail = 0;
        componentMap[index] = componentId;
        componentQueue[tail] = index;
        tail += 1;

        while (head < tail) {
          var current = componentQueue[head];
          var currentX;
          var currentY;
          var next;
          head += 1;

          currentX = current % width;
          currentY = (current - currentX) / width;

          component.area += 1;
          component.minX = Math.min(component.minX, currentX);
          component.maxX = Math.max(component.maxX, currentX);
          component.minY = Math.min(component.minY, currentY);
          component.maxY = Math.max(component.maxY, currentY);
          if (currentX >= centerMin && currentX <= centerMax) component.centerHits += 1;

          if (currentX > 0) {
            next = current - 1;
            if (canVisit(next)) {
              componentMap[next] = componentId;
              componentQueue[tail] = next;
              tail += 1;
            }
          }

          if (currentX < width - 1) {
            next = current + 1;
            if (canVisit(next)) {
              componentMap[next] = componentId;
              componentQueue[tail] = next;
              tail += 1;
            }
          }

          if (currentY > 0) {
            next = current - width;
            if (canVisit(next)) {
              componentMap[next] = componentId;
              componentQueue[tail] = next;
              tail += 1;
            }
          }

          if (currentY < height - 1) {
            next = current + width;
            if (canVisit(next)) {
              componentMap[next] = componentId;
              componentQueue[tail] = next;
              tail += 1;
            }
          }
        }

        components.push(component);
      }

      var largestArea = 0;
      var selected = new Uint8Array(components.length + 1);
      for (index = 0; index < components.length; index += 1) {
        largestArea = Math.max(largestArea, components[index].area);
      }

      for (index = 0; index < components.length; index += 1) {
        var item = components[index];
        var overlapsCore = item.maxX >= width * 0.32 && item.minX <= width * 0.68;
        var isMainArea = item.area === largestArea;
        var isCentralArea = item.centerHits > Math.max(6, item.area * 0.015) && item.area > largestArea * 0.025;
        var isLargeCoreArea = item.area > largestArea * 0.18 && overlapsCore;

        if (isMainArea || isCentralArea || isLargeCoreArea) {
          selected[index + 1] = 1;
        }
      }

      var bodyMask = new Uint8Array(pixelCount);
      for (index = 0; index < pixelCount; index += 1) {
        if (selected[componentMap[index]]) bodyMask[index] = 1;
      }

      for (var bleedPass = 0; bleedPass < 7; bleedPass += 1) {
        var expandedBodyMask = bodyMask.slice();

        for (y = 1; y < height - 1; y += 1) {
          for (x = 1; x < width - 1; x += 1) {
            index = (y * width) + x;
            if (!bodyMask[index]) continue;

            for (var bleedY = -1; bleedY <= 1; bleedY += 1) {
              for (var bleedX = -1; bleedX <= 1; bleedX += 1) {
                var bleedIndex = ((y + bleedY) * width) + x + bleedX;
                if (!outside[bleedIndex]) expandedBodyMask[bleedIndex] = 1;
              }
            }
          }
        }

        bodyMask = expandedBodyMask;
      }

      var mask = document.createElement('canvas');
      var maskContext = mask.getContext('2d');
      var maskData = sourceContext.createImageData(width, height);
      var maskPixels = maskData.data;

      mask.width = width;
      mask.height = height;

      for (index = 0; index < pixelCount; index += 1) {
        if (bodyMask[index]) {
          var pixel = index * 4;
          maskPixels[pixel] = 0;
          maskPixels[pixel + 1] = 0;
          maskPixels[pixel + 2] = 0;
          maskPixels[pixel + 3] = 255;
        }
      }

      maskContext.putImageData(maskData, 0, 0);

      return {
        canvas: mask,
        width: width,
        height: height
      };
    }

    function setupUploadedBody(side, topColor, bottomColor) {
      var element = section.querySelector('[data-uploaded-body="' + side + '"]');
      if (!element) return null;

      var image = element.querySelector('[data-body-image="' + side + '"]');
      var canvas = element.querySelector('[data-body-canvas="' + side + '"]');
      if (!image || !canvas) return null;

      var renderer = {
        element: element,
        image: image,
        canvas: canvas,
        context: canvas.getContext('2d'),
        buffer: document.createElement('canvas'),
        bufferContext: null,
        mask: null,
        ready: false,
        readyCallbacks: [],
        pendingPercent: 0,
        baseColor: cssVar('--tbfa-body-shell', '#EFF2EE'),
        topColor: topColor,
        bottomColor: bottomColor
      };

      renderer.bufferContext = renderer.buffer.getContext('2d');

      function init() {
        try {
          renderer.mask = buildSilhouetteMask(image);
          renderer.ready = true;
          renderUploadedBody(renderer, renderer.pendingPercent);
          while (renderer.readyCallbacks.length) {
            renderer.readyCallbacks.shift()();
          }
        } catch (error) {
          renderer.ready = true;
          while (renderer.readyCallbacks.length) {
            renderer.readyCallbacks.shift()();
          }
          if (window.console && window.console.warn) {
            window.console.warn('TOQUI PNG body fill could not read this image mask.', error);
          }
        }
      }

      if (image.complete && image.naturalWidth) {
        init();
      } else {
        image.addEventListener('load', init, { once: true });
      }

      return renderer;
    }

    function renderUploadedBody(renderer, percent) {
      var safePercent = Math.max(0, Math.min(100, percent));
      renderer.pendingPercent = safePercent;

      if (!renderer.ready || !renderer.mask) return;

      var width = Math.round(renderer.image.clientWidth || renderer.element.clientWidth);
      var height = Math.round(renderer.image.clientHeight || (width * renderer.mask.height / renderer.mask.width));
      if (width < 2 || height < 2) return;

      var ratio = Math.min(window.devicePixelRatio || 1, 2);
      var pixelWidth = Math.max(1, Math.round(width * ratio));
      var pixelHeight = Math.max(1, Math.round(height * ratio));

      if (renderer.canvas.width !== pixelWidth || renderer.canvas.height !== pixelHeight) {
        renderer.canvas.width = pixelWidth;
        renderer.canvas.height = pixelHeight;
      }

      if (renderer.buffer.width !== width || renderer.buffer.height !== height) {
        renderer.buffer.width = width;
        renderer.buffer.height = height;
      }

      var context = renderer.context;
      var bufferContext = renderer.bufferContext;
      var currentHeight = height * (safePercent / 100);
      var currentY = height - currentHeight;
      var gradient = bufferContext.createLinearGradient(0, height, 0, currentY);

      context.setTransform(ratio, 0, 0, ratio, 0, 0);
      context.clearRect(0, 0, width, height);

      bufferContext.setTransform(1, 0, 0, 1, 0, 0);
      bufferContext.clearRect(0, 0, width, height);
      bufferContext.globalCompositeOperation = 'source-over';
      bufferContext.drawImage(renderer.mask.canvas, 0, 0, width, height);

      bufferContext.globalCompositeOperation = 'source-in';
      bufferContext.fillStyle = renderer.baseColor;
      bufferContext.fillRect(0, 0, width, height);

      gradient.addColorStop(0, renderer.bottomColor);
      gradient.addColorStop(1, renderer.topColor);
      bufferContext.fillStyle = gradient;
      bufferContext.fillRect(0, currentY, width, currentHeight);
      bufferContext.globalCompositeOperation = 'source-over';

      context.drawImage(renderer.buffer, 0, 0, width, height);
    }

    var leftRenderer = setupUploadedBody(
      'left',
      cssVar('--tbfa-left-top', '#C2CFC9'),
      cssVar('--tbfa-left-bottom', '#E5EBE7')
    );
    var rightRenderer = setupUploadedBody(
      'right',
      cssVar('--tbfa-right-top', '#2D6459'),
      cssVar('--tbfa-right-bottom', '#B6E09B')
    );

    function renderersReady() {
      return (!leftRenderer || leftRenderer.ready) && (!rightRenderer || rightRenderer.ready);
    }

    function whenRenderersReady(callback) {
      var called = false;

      function done() {
        if (called || !renderersReady()) return;
        called = true;
        callback();
      }

      if (leftRenderer && !leftRenderer.ready) leftRenderer.readyCallbacks.push(done);
      if (rightRenderer && !rightRenderer.ready) rightRenderer.readyCallbacks.push(done);
      done();
    }

    function setFill(rect, percent) {
      var safePercent = Math.max(0, Math.min(100, percent));
      if (!rect) return;

      if (rect.tagName && rect.tagName.toLowerCase() === 'rect') {
        var currentHeight = fillHeight * (safePercent / 100);
        var currentY = fillBottom - currentHeight;
        rect.setAttribute('y', currentY.toFixed(2));
        rect.setAttribute('height', currentHeight.toFixed(2));
        return;
      }

      rect.style.height = safePercent.toFixed(2) + '%';
    }

    function setSide(side, value) {
      if (side === 'left') {
        if (leftRenderer) {
          renderUploadedBody(leftRenderer, value);
        } else {
          setFill(leftFill, value);
        }

        leftCounter.textContent = Math.round(value);
        return;
      }

      if (rightRenderer) {
        renderUploadedBody(rightRenderer, value);
      } else {
        setFill(rightFill, value);
      }

      rightCounter.textContent = Math.round(value);
    }

    function renderFinalState() {
      hasPlayed = true;
      stage.classList.add('is-visible');
      setSide('left', leftTarget);
      setSide('right', rightTarget);
    }

    function resetState() {
      setSide('left', 0);
      setSide('right', 0);
    }

    function animateIn() {
      if (hasPlayed) return;
      if (!renderersReady()) {
        whenRenderersReady(animateIn);
        return;
      }

      hasPlayed = true;
      stage.classList.add('is-visible');

      if (!shouldAnimate || reducedMotion || !window.requestAnimationFrame) {
        renderFinalState();
        return;
      }

      var startTime = null;
      var totalDuration = duration + Math.max(delays[0], delays[1]);

      function progressFor(elapsed, delay) {
        if (elapsed <= delay) return 0;
        return easeOutCubic(Math.min((elapsed - delay) / duration, 1));
      }

      function frame(timestamp) {
        if (!startTime) startTime = timestamp;
        var elapsed = timestamp - startTime;
        var leftProgress = progressFor(elapsed, delays[0]);
        var rightProgress = progressFor(elapsed, delays[1]);

        setSide('left', leftTarget * leftProgress);
        setSide('right', rightTarget * rightProgress);

        if (elapsed < totalDuration) {
          requestFrame(frame);
        } else {
          renderFinalState();
        }
      }

      requestFrame(frame);
    }

    function scheduleAnimation() {
      if (hasPlayed || animationDelayTimer) return;

      animationDelayTimer = window.setTimeout(function () {
        animationDelayTimer = null;
        animateIn();
      }, animationDelay);
    }

    function isSectionInView() {
      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      return rect.top < viewportHeight * 0.65 && rect.bottom > viewportHeight * 0.2;
    }

    function checkFallbackInView() {
      if (fallbackStarted || hasPlayed || !isSectionInView()) return;
      fallbackStarted = true;
      window.removeEventListener('scroll', checkFallbackInView);
      window.removeEventListener('resize', checkFallbackInView);
      scheduleAnimation();
    }

    resetState();

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) {
          observer.disconnect();
          scheduleAnimation();
        }
      }, { threshold: 0.35 });

      observer.observe(section);
    } else {
      window.addEventListener('scroll', checkFallbackInView, { passive: true });
      window.addEventListener('resize', checkFallbackInView);
      checkFallbackInView();
    }
var alignFrame = null;
    function alignIngredientCards() {
      var ingredients = section.querySelector('.tbfa-ingredients');
      var ingredientGrid = section.querySelector('.tbfa-ingredients__grid');
      var stats = section.querySelectorAll('.tbfa-stat');
      var isDesktop = window.matchMedia && window.matchMedia('(min-width: 991px)').matches;

      if (!ingredients || !ingredientGrid || !stats.length || !isDesktop) {
        if (ingredients) ingredients.style.setProperty('--tbfa-ingredient-align-y', '0px');
        return;
      }

      ingredients.style.setProperty('--tbfa-ingredient-align-y', '0px');

      var statBottom = 0;
      stats.forEach(function (stat) {
        statBottom = Math.max(statBottom, stat.getBoundingClientRect().bottom);
      });

      var ingredientBottom = ingredientGrid.getBoundingClientRect().bottom;
      var offset = statBottom - ingredientBottom;

      ingredients.style.setProperty('--tbfa-ingredient-align-y', offset.toFixed(2) + 'px');
    }

    function requestIngredientAlignment() {
      if (alignFrame) return;
      alignFrame = requestFrame(function () {
        alignFrame = null;
        alignIngredientCards();
      });
    }

    requestIngredientAlignment();

    function handleResize() {
      if (hasPlayed) renderFinalState();
      requestIngredientAlignment();
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', requestIngredientAlignment, { passive: true });

    initializedSections.set(section, {
      destroy: function () {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('scroll', requestIngredientAlignment);
        if (observer) observer.disconnect();
        if (animationDelayTimer) window.clearTimeout(animationDelayTimer);
        window.removeEventListener('scroll', checkFallbackInView);
        window.removeEventListener('resize', checkFallbackInView);
      }
    });
  }

  function initAll(root) {
    forEachSection(root, initSection);
  }

  function destroyAll(root) {
    forEachSection(root, function (section) {
      var state = initializedSections.get(section);
      if (state && typeof state.destroy === 'function') state.destroy();
      initializedSections.delete(section);
    });
  }

  window[namespace] = {
    initSection: initSection,
    initAll: initAll,
    destroyAll: destroyAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });
})();